export const BRAND = {
  product: 'Alor',
  tagline: 'Enterprise Governance, Risk & Compliance',
  copilot: 'Alora AI',
  copilotShort: 'Alora',
  parentCompany: 'Risx AI',
  productAttribution: 'An Alor product by Risx AI',
  copilotAttribution: 'Powered by Risx AI',
  logoSrc: '/allor-logo.svg',
  iconSrc: '/brain-icon.png',
};
